import { ErrorText } from "../constants";
import { useOverlayContext, useStoreActions } from "../contexts";
import { ServerError } from "../infra/ErrorResponse";
import { handleRequest } from "../infra/utils";
import { useFeatureFlags } from "./useFeatureFlags";
const loaderName = 'updateRelationship';
export function useUpdateRelationship() {
  const {
    api
  } = useStoreActions();
  const {
    startLoader,
    stopLoader,
    showErrorToast,
    showSuccessToast
  } = useOverlayContext();
  const {
    START_BILLING_AT
  } = useFeatureFlags();
  return async function updateRelationship(_ref) {
    let {
      id,
      version,
      changes,
      onSuccess
    } = _ref;
    startLoader(loaderName);
    const updateResult = await handleRequest(START_BILLING_AT ? api.relationship.update(id, {
      version,
      changes
    }) : api.relationship.updateOld(id, {
      version,
      changes
    }));
    if (!updateResult.success) {
      showErrorToast(updateResult.error.hasServerError(ServerError.MismatchingRelationshipVersion) ? ErrorText.MismatchingRelationshipVersion : ErrorText.UnexpectedErrorTryAgain, 'edit-agr-error');
      return stopLoader(loaderName);
    }
    onSuccess && (await onSuccess());
    showSuccessToast('Changes saved successfully', 'edit-agr-success');
    stopLoader(loaderName);
  };
}